import SectionHeading from '@/components/base/SectionHeading';
import { steps } from '@/mocks/home';

interface Props {
  items?: { num: string; title: string; text: string }[];
  eyebrow?: string;
  title?: string;
}

export default function Process({ items = steps, eyebrow = 'HOW IT WORKS', title = 'A Cleaner Home in Three Easy Steps.' }: Props) {
  return (
    <section className="py-16 md:py-20 lg:py-[112px] px-4 md:px-6 lg:px-20 bg-background-100">
      <div className="max-w-content mx-auto">
        <SectionHeading eyebrow={eyebrow} title={title} />
        <ol data-reveal-group className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
          {items.map((s, i) => (
            <li key={s.num} className="rounded-2xl bg-background-50 border border-background-300 p-6 md:p-8">
              <span className={`inline-flex w-12 h-12 rounded-full items-center justify-center text-sm font-medium ${i === 0 ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-secondary-500'}`}>{s.num}</span>
              <h3 className="mt-8 font-heading text-[22px] lg:text-[26px] leading-[1.25] font-medium">{s.title}</h3>
              <p className="mt-3 text-[15px] md:text-base leading-[1.6] text-foreground-600">{s.text}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}